import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6b5e1b22&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b5e1b22')) {
      api.createRecord('6b5e1b22', component.options)
    } else {
      api.reload('6b5e1b22', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6b5e1b22&", function () {
      api.rerender('6b5e1b22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/resources/index.vue"
export default component.exports